import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Button,
  Grid,
} from '@material-ui/core';
import GetApp from '@material-ui/icons/GetApp';
import { doFetch } from '../../../services/fetch/fetch.actions';
import {
  fetchUser, fetchHistoryUser,
} from '../../../services/admin/user-service';
import InfoCard from '../../../components/card';
import * as userConstants from './functions/constants';

class InfoUser extends Component {
  componentDidMount() {
    const { dispatch, match: { params: { id } }, history } = this.props;
    dispatch(doFetch('GET_USER', fetchUser(id)
      .then((res) => {
        if (!res.ok) {
          history.push('/admin');
          return res.statusText;
        }
        return res.json();
      })));
    dispatch(doFetch('HISTORY_USER', fetchHistoryUser(id)
      .then((res) => {
        if (!res.ok) {
          history.push('/admin');
          throw res;
        }
        return res.json();
      })));
  }

  render() {
    const {
      classes, history,
      currentUser: {
        fetching, fetched, error, payload: { Resources: data },
      },
      historyUser: { payload: userHistory, fetched: historyFetched, error: historyError },
    } = this.props;

    const {
      contact, work, party, historyParties, historyCommittees, roles, committees,
    } = fetched && historyFetched && !error && !historyError ? {
      contact: {
        Navn: `${data.givenName || ''} ${data.familyName || ''}`,
        // Kjønn: data.politicianData.sex === 'm' ? 'Mann' : 'Kvinne',
        'E-post': data.email || '',
        Telefon: data.phone ? `+47 ${data.phone}` : '',
        Adresse: data.streetAddress && data.zipCode && data.city
          ? `${data.streetAddress}, ${data.zipCode} ${data.city}` : '',
      },
      roles: data.roles,
      work: data.roles && data.roles.indexOf('politician') > -1 ? {
        Arbeidssted: data.workplace,
        Bankkontonummer: data.bankAccount,
        'Relevant informasjon': data.generalInfo,
      } : null,
      party: data.parties ? {
        Parti: data.parties[0].display || data.party.name,
      } : null,
      committees: data.committees ? data.committees.map(item => ({
        Fra: new Date(item.from).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' }),
        Til: item.to && item.to !== '0001-01-01T00:00:00Z'
          ? new Date(item.to).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' }) : 'Dagens dato',
        Utvalg: item.display || '',
        role: item.role || '',
      })) : null,
      historyParties: userHistory && userHistory.parties
        ? userHistory.parties.map(item => ({
          Fra: new Date(item.from).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' }),
          Til: item.to ? new Date(item.to).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' }) : 'Dagens dato',
          Parti: item.display || item.partyName,
        })) : null,
      historyCommittees: userHistory && userHistory.committees
        ? userHistory.committees.map(item => ({
          Fra: new Date(item.from).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' }),
          Til: item.to ? new Date(item.to).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' }) : 'Dagens dato',
          Utvalg: item.display || item.committeeName,
          role: item.role || '',
        })) : null,
    } : {};

    return (
      <div className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Typography variant="h4" color="primary" className={classes.title}>
              Informasjon om bruker
            </Typography>
          </Grid>
          {fetched && ((historyCommittees && historyCommittees.length > 0) || (committees && committees.length > 0)) && [
            <Grid item xs={6} md={2} key={1}>
              <Button
                fullWidth
                variant="outlined"
                endIcon={<GetApp />}
                color="primary"
                onClick={() => window.open(`${window.location.origin}/idp-auth/pbasen/admin/ExportUser?id=${data.id}&format=csv`, '_blank').opener}
              >
                CSV
              </Button>
            </Grid>,
            <Grid item xs={6} md={2} key={2}>
              <Button
                fullWidth
                variant="outlined"
                endIcon={<GetApp />}
                color="primary"
                onClick={() => window.open(`${window.location.origin}/idp-auth/pbasen/admin/ExportUser?id=${data.id}&format=pdf`, '_blank').opener}
              >
                PDF
              </Button>
            </Grid>,
          ]}
        </Grid>
        <Grid container spacing={2}>
          {[
            fetching && <Grid item xs={12} key="skeleton"><InfoCard key={1} value={[<Skeleton width="30rem" key="skeleton" />]} isLoading /></Grid>,
            fetched && roles && (
              <Grid item xs={12} key={10}>
                <InfoCard
                  key={2}
                  value={roles}
                  title={data.roles.length > 1 ? 'Roller' : 'Rolle'}
                  roles
                />
              </Grid>
            ),
            party && (
              <Grid item xs={12} key={1}>
                <InfoCard
                  key={4}
                  value={party}
                  title="Parti"
                />
              </Grid>
            ),
            contact && (
              <Grid item xs={12} key={2}>
                <InfoCard
                  key={2}
                  value={contact}
                  title="Kontaktinformasjon"
                />
              </Grid>
            ),
            work && (
              <Grid item xs={12} key={3}>
                <InfoCard
                  key={3}
                  value={work}
                  title="Arbeid"
                />
              </Grid>
            ),
            committees && committees.length > 0 && (
              <Grid item xs={12} key={4}>
                <InfoCard
                  key={6}
                  value={committees}
                  title="Nåværende utvalg"
                />
              </Grid>
            ),
            historyParties && historyParties.length > 0 && (
              <Grid item xs={12} key={5}>
                <InfoCard
                  key={4}
                  value={historyParties}
                  title="Partitilhørighet"
                />
              </Grid>
            ),
            historyCommittees && historyCommittees.length > 0 && (
              <Grid item xs={12} key={6}>
                <InfoCard
                  key={5}
                  value={historyCommittees}
                  title="Utvalgshistorikk"
                />
              </Grid>
            ),
          ]}
          {fetched && (
            <Grid container direction='row' justifyContent='space-between' alignItems='center'>
              <Grid item key={1}>
                <Button variant="outlined" onClick={() => window.history.back()}>
                  Tilbake
                </Button>
              </Grid>
              <Grid item key={2}>
                <Button
                  key={0}
                  variant="contained"
                  color={data.active === userConstants.ENABLED ? "primary" : "secondary"}
                  onClick={() => { history.push(`/admin/users/endre-${data.id}`); }}
                >
                  {// eslint-disable-next-line no-nested-ternary
                    data.active === userConstants.ENABLED ? 'Rediger' : data.active !== userConstants.PENDING ? 'Aktiver' : 'Behandle søknad'}
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

InfoUser.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.any.isRequired,
  match: PropTypes.any.isRequired,
  currentUser: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  historyUser: PropTypes.object.isRequired,
};

const styles = () => ({
  title: {
    marginBottom: '1.5rem',
  },
  container: {
    maxWidth: '60rem',
    marginBottom: '4rem',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'bottom',
    marginBottom: '1rem',
    flexWrap: 'wrap-reverse',
  },
  button: {
    minWidth: '13rem',
    marginTop: '8px', // same as Material Ui TextField
    marginBottom: '4px', // same as Material UI TextField
  },
  search: {
    minWidth: '17rem',
  }
});

const mapStateToProps = ({ currentUser, historyUser }) => ({ currentUser, historyUser });

export default connect(mapStateToProps)(withStyles(styles)(InfoUser));
